import { Fragment, useEffect, useState } from "react";
import { useDeleteLocationMutation } from "../../store/services/jobs";

import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";

import { useToast } from "@chakra-ui/react";
import Modal from "../Modal";

const LocationCard = ({ l, setLocationEdit, setLocationVal, handleGetLocations }) => {
  const [deleteLocation, { isSuccess: deleteLocationSuccess, isError: deleteLocationError }] = useDeleteLocationMutation();

  const toast = useToast();

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    if (deleteLocationSuccess) {
      toast({
        title: "Location Deleted Successfully",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      handleGetLocations();
      setDeleteModal(false);
    }
    if (deleteLocationError) {
      toast({
        title: "Error Deleting Location",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setDeleteModal(false);
    }
  }, [deleteLocationSuccess, deleteLocationError]);
  return (
    <>
      <div className="flex justify-between items-center bg-gray-200 px-2 py-1 ">
        <span>{l?.c_l_title}</span>
        <span className="flex gap-2 items-center">
          <span
            onClick={() => {
              setLocationVal(l?.c_l_title);
              setLocationEdit(l);
            }}
            className="cursor-pointer "
          >
            <MdEdit />
          </span>
          <span
            onClick={() => {
              setDeleteModal(true);
              setDeleteId(l?.c_l_id);
            }}
            className="cursor-pointer"
          >
            <MdDelete />
          </span>
        </span>
      </div>
      {deleteModal && (
        <Modal
          onClose={() => {
            setDeleteModal(false);
            setDeleteId(null);
          }}
        >
          <div>
            <h4 className="text-lg font-medium mb-3 text-center">Are you sure you want to delete?</h4>
            <div className="flex gap-4">
              <button onClick={() => deleteLocation(deleteId)} className="bg-black text-white rounded-lg px-4 py-2 w-full">
                Yes
              </button>
              <button
                onClick={() => {
                  setDeleteModal(false);
                  setDeleteId(null);
                }}
                className="border border-black rounded-lg px-4 py-2 w-full"
              >
                No
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default LocationCard;
